import React, { useState } from 'react'
import { connect } from 'react-redux'
import BasicLgySelectField from 'app/components/util/lgy-select-field/BasicLgySelectField'
import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import NADLDateRangeReport from 'app/gears/nadl/components/NADLDateRangeReport'
import NADLLoanCommitmentReport from 'app/gears/nadl/components/NADLLoanCommitmentReport'
import { fetchDateRangeReport } from 'app/gears/nadl/actions/nadlActions'

let NADLRunReports = (props) => {
  const dateRegex = /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/
  const [selectedReportType, setSelectedReportType] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [error, setError] = useState(false)

  const handleSelectChange = (e) =>
    setSelectedReportType(e.target.value)

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedReportType === 'dateRange') {
      if (!(dateRegex.test(fromDate) && dateRegex.test(toDate))) {
        setError(true)
        setSubmitted(false)
      } else {
        setError(false)
        props.fetchDateRangeReport(fromDate, toDate)
        setSubmitted(true)
      }
    } else {
      setSubmitted(true)
    }
  }

  const handleReset = () => {
    setError(false)
    setSelectedReportType('')
    setFromDate('')
    setToDate('')
    setSubmitted(false)
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'NADL Records',
        columns: [
          {
            Header: "Id",
            accessor: "id"
          },
          {
            Header: 'Commitment Date',
            accessor: 'dateCommitmentIssued'
          },
          {
            Header: 'LIN',
            accessor: 'lin',
          },
          {
            Header: 'First Name',
            accessor: 'firstName'
          }, {
            Header: 'Middle Initial',
            accessor: 'mi'
          },
          {
            Header: 'Last Name',
            accessor: 'lastName',
            sortType: 'basic'
          },
          {
            Header: 'Date Added',
            accessor: 'dateAdded',
          },
        ],
      },
    ],
    []
  )

  return (
    <div>
      <h3>Native American Direct Loan Data Reporting</h3>
      {!submitted &&
        <>
          <p>Please select a report type from below and click <b>Run Report</b>.</p>
          <form onSubmit={handleSubmit}>
            <BasicLgySelectField label='Report Type' name='reportType' id='reportType' onClick={handleSelectChange} required>
              <option value='dateRange'>Date Range Report</option>
              <option value='loanCommitment'>Loan Commitment Cumulative Amount Report</option>
            </BasicLgySelectField>
            {selectedReportType === 'dateRange' &&
              <>
                {error && <LgyAlertDialog type='error' heading='Invalid Date' text={`One or more of the dates you entered is not of format: MM/DD/YYYY. Please correct and resubmit.`} />}
                <BasicLgyInputField
                  label='From Date'
                  name='fromDate'
                  placeholder='MM/DD/YYYY'
                  value={fromDate}
                  onChange={e => setFromDate(e.target.value)}
                  required />
                <BasicLgyInputField
                  label='To Date'
                  name='toDate'
                  placeholder='MM/DD/YYYY'
                  value={toDate}
                  onChange={e => setToDate(e.target.value)}
                  required />
              </>
            }
            <button type='submit'>Run Report</button>
          </form>
        </>}
      {submitted &&
        ((selectedReportType === 'dateRange' &&
          (!props.fetching && props.nadlRecords ? <NADLDateRangeReport fromDate={fromDate} toDate={toDate} handleReset={handleReset} columns={columns} data={props.nadlRecords.reverse()} />
            : <h4>Loading...</h4>))
          || (selectedReportType === 'loanCommitment' && <NADLLoanCommitmentReport handleReset={handleReset} />))
      }
    </div>
  )
}

const mapStateToProps = state => ({
  ...state.nadlRecords
})
const mapDispatchToProps = { fetchDateRangeReport }

NADLRunReports = connect(mapStateToProps, mapDispatchToProps)(NADLRunReports)


export default NADLRunReports